export enum ReportDataType {
  Count = "Count",
  Shadowing = "Shadowing",
  Top = "Top",
  Company = "Company",
}

interface ReportsDataBase {
  title: string;
}

export interface ReportsDataCounts extends ReportsDataBase {
  type: ReportDataType.Count;
  value: Array<{ value: number; unit: string }>;
}

export interface ReportsDataShadowing extends ReportsDataBase {
  type: ReportDataType.Shadowing;
  value: ShadowingLike[];
}

export interface ReportsDataTop extends ReportsDataBase {
  type: ReportDataType.Top;
  unit?: string;
  value: Array<{ title: string; value: number }>;
}

export interface ReportsDataCompany extends ReportsDataBase {
  type: ReportDataType.Company;
  value: Array<{ id: number; title: string; logoUrl?: string; value: number }>;
}

export type ReportsData = ReportsDataCounts | ReportsDataShadowing | ReportsDataTop | ReportsDataCompany;

export interface ShadowingLike {
  id: number;
  position: string;
  visitsCount: number;
  companyTitle?: string;
  companyLogoUrl?: string;
}

export interface ReportsCompanyStatsResponse {
  shadowingsCount: number;
  applicationCount: number;
  visitsCount: number;
  bestShadowings: ShadowingLike[];
}

export interface ReportsSchoolStatsResponse {
  applicationCount: number;
  visitsCount: number;
  totalRegisteredStudentsCount: number;
  finishedProgramCount: number;
  mostActiveGrades: Array<{ count: number; grade: string; schoolName?: string }>;
  bestShadowings: ShadowingLike[];
  bestCompanies: Array<{ id: number; visitsCount: number; companyTitle: string; companyLogoUrl: string }>;
  bestCompaniesNationwide: Array<{ id: number; visitsCount: number; companyTitle: string; companyLogoUrl: string }>;
}

export interface ReportsMunicipalityStatsResponse {
  shadowingsCount: number;
  applicationCount: number;
  visitsCount: number;
  totalRegisteredStudentsCount: number;
  finishedProgramCount: number;
  mostActiveGrades: Array<{ count: number; grade: string; schoolName?: string }>;
  bestShadowings: ShadowingLike[];
  bestCompanies: Array<{ id: number; visitsCount: number; companyTitle: string; companyLogoUrl: string }>;
  bestSchools: Array<{ id: number; visitsCount: number; name: string }>;
}

export interface ReportFilterResponse {
  companies: Array<{ id: number; name: string }>;
  schools: Array<{ id: number; name: string }>;
  grades: Array<string | number>;
  years: number[];
}

export enum ApplicationStatus {
  CompanyApproved = 1,
  CompanyRejected = 2,
  StudentCancelled = 3,
  SchoolCancelled = 4,
  CompanyCancelled = 5,
  Outdated = 6,
  WaitingForSchoolApproval = 7,
  WaitingForCompanyApproval = 8,
  WaitingForAdminApproval = 9,
  AdminRejected = 10,
}

export const APPLICATION_STATUS_LABELS: Record<ApplicationStatus, string> = {
  [ApplicationStatus.CompanyApproved]: "Patvirtinta",
  [ApplicationStatus.WaitingForCompanyApproval]: "Laukia įmonės patvirtinimo",
  [ApplicationStatus.WaitingForSchoolApproval]: "Laukia mokyklos patvirtinimo",
  [ApplicationStatus.WaitingForAdminApproval]: "Laukia administratoriaus",
  [ApplicationStatus.CompanyRejected]: "Atmesta įmonės",
  [ApplicationStatus.AdminRejected]: "Atmesta administratoriaus",
  [ApplicationStatus.StudentCancelled]: "Atšaukta studento",
  [ApplicationStatus.SchoolCancelled]: "Atšaukta mokyklos",
  [ApplicationStatus.CompanyCancelled]: "Atšaukta įmonės",
  [ApplicationStatus.Outdated]: "Pasibaigė",
};

export const PARTICIPANT_STATUS_OPTIONS = [
  { value: ApplicationStatus.CompanyApproved, text: "Patvirtinta" },
  { value: ApplicationStatus.WaitingForCompanyApproval, text: "Laukia įmonės patvirtinimo" },
  { value: ApplicationStatus.WaitingForSchoolApproval, text: "Laukia mokyklos patvirtinimo" },
  { value: ApplicationStatus.StudentCancelled, text: "Atšaukta studento" },
  { value: ApplicationStatus.CompanyCancelled, text: "Atšaukta įmonės" },
];

export interface CompanyParticipant {
  fullName: string;
  email: string;
  phoneNumber: string;
  grade: string;
  school: string;
  position: string;
  date: string;
  endDate?: string;
  isInternship: boolean;
  noShow: boolean;
  status: ApplicationStatus;
}
